/** @jsx jsx */

import { css, jsx, keyframes } from '@emotion/core';
import { Text } from '@zapier/common-components';
import { Icon } from '@zapier/design-system';
import { ReactNode } from 'react';
import Chart from './chart.svg';

const animationLoading = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
`;

const styleChartBase = css`
  height: 57px;
  width: 100%;
`;

const styleChartLoading = css`
  ${styleChartBase}
  animation: ${animationLoading} 1s ease-in-out infinite;
`;

const styleContainer = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const styleContainerLoading = css`
  ${styleContainer}
  /* Default chart height */
  min-height: 375px;
`;

export function LoadingStatus() {
  return (
    <div css={styleContainerLoading}>
      <Chart css={styleChartLoading} />
      <Text tag="p" type="SmallPrint3">
        Loading...
      </Text>
    </div>
  );
}

export function NoResultsStatus() {
  return (
    <div css={styleContainer}>
      <Chart css={styleChartBase} />
      <Text tag="p" type="SmallPrint3">
        No results
      </Text>
    </div>
  );
}

export function CustomStatus({ children }: { children: ReactNode }) {
  return (
    <div css={styleContainer}>
      <Chart css={styleChartBase} />
      {children}
    </div>
  );
}

export function UnableToLoadStatus() {
  return (
    <div css={styleContainer}>
      <Icon name="alertTriangleFill" size={30} />
      <Text tag="p" type="SmallPrint3">
        Unable to load data
      </Text>
    </div>
  );
}
